<template>
    <div>

        <template v-if="groups.length > 0">

        <div class="columns no-print">
            <div class="column is-offset-2 is-two-thirds">
                <b-field
                    label="Отображать расписание"
                    class="has-text-centered">
                    <b-field>
                        <b-radio-button
                            v-if="filterGroupsByType('regular').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="regular">
                            <span>
                                {{ $t('schedule.group_type.regular') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('linguistic-primary').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="linguistic-primary">
                            <span>
                                {{ $t('schedule.group_type.linguistic-primary') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('linguistic-secondary').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="linguistic-secondary">
                            <span>
                                {{ $t('schedule.group_type.linguistic-secondary') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('bachelor').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="bachelor">
                            <span>
                                {{ $t('schedule.group_type.bachelor') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('master').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="master">
                            <span>
                                {{ $t('schedule.group_type.master') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('graduate').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="graduate">
                            <span>
                                {{ $t('schedule.group_type.graduate') }}
                            </span>
                        </b-radio-button>
                        <b-radio-button
                            v-if="filterGroupsByType('optional').length"
                            class="is-expanded"
                            v-model="internalGroupType"
                            native-value="optional">
                            <span>
                                {{ $t('schedule.group_type.optional') }}
                            </span>
                        </b-radio-button>
                    </b-field>
                </b-field>
            </div>
        </div>

        <div class="print-only">
            <br>
            <h6 class="title has-text-centered">
                {{ $t(`schedule.group_description.${internalGroupType}`) }}
            </h6>
        </div>

        <p class="has-text-centered" v-if="!isCurrent">
            <small>* Название группы в другом учебном году</small>
        </p>

        <div class="day" v-for="day in filteredDays" :key="day">
            <h3 class="title is-3 has-text-centered has-text-weight-light">
                <span>{{ $t(`dates.days.${day}`) }}</span>
            </h3>

            <div class="schedule-wrapper">
                <table class="schedule table is-fullwidth"
                    :class="{ 'is-interactive': isInteractive }">
                    <thead>
                        <tr v-if="currentLinguisticGroup">
                            <th></th>
                            <th
                                v-for="chunk in linguisticGroupChunks"
                                :colspan="chunk.colspan"
                                :key="chunk.title"
                                class="has-text-weight-light has-text-centered">
                                {{ chunk.title }}
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th
                                v-for="group in filteredGroupsByType"
                                :key="group.id"
                                class="has-text-weight-light has-text-centered">
                                <a :href="group.url" target="_self">
                                {{ timeAdjustedGroupTitle(group) }}
                                </a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(classtime, index) in filteredClasstimes[day]"
                            :key="index">

                            <th class="has-text-weight-light">
                                {{ classtime.start }}
                            </th>
                            
                            <td
                                v-for="(result, index) in filteredGroups[day][classtime.id]"
                                :colspan="result.colspan"
                                :key="index">
                                <schedule-entry
                                    :class="{
                                        'is-hover': entry.id == hoverEntry
                                    }"
                                    @mouseover.native="() => {
                                        hoverEntry = entry.id
                                    }"
                                    @mouseout.native="() => {
                                        hoverEntry = null
                                    }"
                                    @click="entry => $emit('click', entry)"
                                    v-for="(entry, index) in orderEntries(result.entries)"
                                    :key="index"
                                    :data="entry"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        </template>

        <template v-else>

            <div class="container has-text-centered">
                <br>
                <br>
                <br>
                <h4 class="subtitle is-4 has-text-centered">
                    Нет доступных групп для отображения
                </h4>
            </div>

        </template>

    </div>
</template>

<script>
export default Vue.extend({
  props: {
    isInteractive: Boolean,
    isCompact: {
      type: Boolean,
      default: false
    },
    schedule: {
      type: Object,
      required: true
    },
    days: {
      type: [Array],
      required: true
    },
    classtimes: {
      type: [Array],
      required: true
    },
    groups: {
      type: [Array],
      required: true
    },
    entries: {
      type: [Array],
      required: true
    },
    groupType: {
      type: String
    }
  },
  data() {
    return {
      internalGroupType: this.groupType,
      hoverEntry: null,
      isCurrent: true
    };
  },
  watch: {
    entries: {
      handler() {},
      immediate: true
    },
    groupType: {
      handler(value) {
        if (!value) {
          this.internalGroupType = this.firstGroupType;
        } else {
          this.internalGroupType = value;
        }
      },
      immediate: true
    },
    internalGroupType: {
      handler(value) {
        this.$emit("update:group-type", value);
      },
      immediate: true
    }
  },
  computed: {
    filteredDays() {
      return _.filter(this.days, day => {
        if (this.isCompact) {
          let result = false;
          _.each(this.classtimes, classtime => {
            _.each(this.filteredGroupsByType, group => {
              result =
                result || this.filterEntries(day, classtime, group).length > 0;
              if (result) {
                return false;
              }
            });
          });
          return result;
        } else {
          return true;
        }
      });
    },
    filteredClasstimes() {
      let result = {};

      for (let day of this.days) {
        result[day] = this.filterClasstimes(day);
      }

      return result;
    },
    currentLinguisticGroup() {
      return this.linguisticGroup(this.internalGroupType);
    },
    filteredGroupsByType() {
      return this.filterGroupsByType(this.internalGroupType);
    },
    filteredGroups() {
      // Compute filtered groups so vue can cache it to
      // avoid calling expensive method every time.
      let result = {};

      for (let day of this.days) {
        result[day] = {};
        for (let classtime of this.classtimes) {
          result[day][classtime.id] = this.filterGroups(day, classtime);
        }
      }

      return result;
    },
    firstGroupType() {
      for (let type of [
        "regular",
        "linguistic-primary",
        "linguistic-secondary",
        "bachelor",
        "master",
        "graduate",
        "optional",
      ]) {
        if (this.filterGroupsByType(type).length) {
          return type;
        }
      }
    },
    linguisticGroupChunks() {
      let result = [];

      if (this.linguisticGroup) {
        let groups = _.uniqBy(
          this.filteredGroupsByType,
          "details.subject.title"
        );
        groups.forEach(group => {
          result.push({
            title: _.trimEnd(group.details.subject.title, " язык"),
            colspan: _.filter(this.filteredGroupsByType, {
              details: {
                subject: {
                  title: group.details.subject.title
                }
              }
            }).length
          });
        });
      }

      return result;
    },
    year() {
      return parseInt(this.schedule.academic_year.split("/")[0]);
    }
  },
  methods: {
    orderEntries(entries) {
      if (entries.length > 1) {
        return _.orderBy(entries, "begin_at", "asc");
      } else {
        return entries;
      }
    },
    filterEntriesByDay(day) {
      return _.filter(this.entries, entry => {
        return entry.day_of_week == day;
      });
    },
    filterEntriesByClasstime(day, classtime) {
      return _.filter(this.entries, entry => {
        return entry.day_of_week == day && entry.classtime.id == classtime.id;
      });
    },
    filterEntriesByGroup(day, group) {
      return _.filter(this.entries, entry => {
        return (
          entry.day_of_week == day && _.find(entry.groups, group) != undefined
        );
      });
    },
    filterEntries(day, classtime, group) {
      return _.intersection(
        this.filterEntriesByClasstime(day, classtime),
        this.filterEntriesByGroup(day, group)
      );
    },
    filterClasstimes(day) {
      return _.filter(this.classtimes, classtime => {
        if (this.isCompact) {
          let result = false;
          _.each(this.filteredGroupsByType, group => {
            result =
              result || this.filterEntries(day, classtime, group).length > 0;
            if (result) {
              return false;
            }
          });
          return result;
        } else {
          return true;
        }
      });
    },
    timeAdjustedGroupTitle(group) {
      let course = Math.ceil(this.schedule.semester.number / 2);

      let title;

      switch (this.internalGroupType) {
        case "linguistic-primary":
        case "linguistic-secondary": {
          title = group.details.number;
          break;
        }
        case "bachelor":
        case "master":
        case "optional":
        case "graduate": {
          title = group.title;
          break;
        }
        default: {
          let current = course == group.course;

          if (this.isCurrent != current) {
            this.isCurrent = current;
          }

          title = course + _.padStart(group.details.number, 2, 0);

          if (!current) {
            title += " *";
          }
        }
      }

      return title;
    },
    linguisticGroup(type) {
      if (type == "linguistic-primary" || type == "linguistic-secondary") {
        return type == "linguistic-primary" ? "primary" : "secondary";
      } else {
        return null;
      }
    },
    filterGroups(day, classtime) {
      // Merge adjacent cells with same entries
      let groups = this.filterGroupsByType(this.internalGroupType);
      let result = [];
      let groupCount = 1;

      for (let i = 0; i < groups.length; i++) {
        let group = groups[i];
        // Get entries from neighbouring cells and check if they are equal.
        let previousEntries = this.filterEntries(day, classtime, group);
        let entries = this.filterEntries(day, classtime, groups[i + 1]);
        let equals = _.isEqual(entries, previousEntries);

        // Transition between states pushes cell into result array.
        // Transition appears when neighbouring cells have different entries.
        let transition = !equals;

        // Transition also appears at the end of the loop.
        transition = transition || i == groups.length - 1;

        // If transition appears, push to the result array and reset counter.
        if (transition) {
          result.push({
            entries: previousEntries,
            colspan: groupCount
          });
          groupCount = 1;
        } else {
          groupCount++;
        }
      }

      return result;
    },
    filterGroupsByType(type) {
      switch (type) {
        case "linguistic-primary":
        case "linguistic-secondary": {
          return _.sortBy(
            _.filter(this.groups, {
              type: "linguistic",
              details: {
                subject: {
                  details: {
                    linguistic: this.linguisticGroup(type)
                  }
                }
              }
            }),
            ["details.subject.title", "details.number"]
          );
          break;
        }
        case "bachelor":
        case "master":
        case "graduate": {
          return _.sortBy(
            _.filter(this.groups, {
              type: type
            }),
            ["title"]
          );
        }
        case "optional": {
          let groups = _.filter(this.groups, {
            type: type
          });

          let result = [];

          for (let group of groups) {
            let semesters = _.get(group.details, 'subject.all_semesters');

            if (semesters.includes(
              this.schedule.semester.number
            )) {
              result.push(group)
            }
          }

          return result;
        }
        default: {
          return _.filter(this.groups, {
            type: type
          });
        }
      }
    }
  }
});
</script>
 


// WEBPACK FOOTER //
// resources/assets/js/components/Schedule.vue